import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.09 5.41004L12 4.33004L10.91 5.41004C7.61 8.72004 6 11.53 6 14C6 15.5913 6.63214 17.1175 7.75736 18.2427C8.88258 19.3679 10.4087 20 12 20C13.5913 20 15.1174 19.3679 16.2426 18.2427C17.3679 17.1175 18 15.5913 18 14C18 11.53 16.39 8.72004 13.09 5.41004ZM11.85 2.00004H12.15C12.3433 1.98939 12.5332 2.05389 12.68 2.18004L14.5 4.00004C17.14 6.64004 20 10.19 20 14C20 16.1218 19.1571 18.1566 17.6569 19.6569C16.1566 21.1572 14.1217 22 12 22C9.87827 22 7.84344 21.1572 6.34315 19.6569C4.84285 18.1566 4 16.1218 4 14C4 10.19 6.86 6.64004 9.5 4.00004L11.32 2.22004C11.4605 2.07934 11.6512 2.00021 11.85 2.00004Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgColorOutline = (props: IconProps) => (
  <SVGUniqueID>{Icon(props)}</SVGUniqueID>
);
export default SvgColorOutline;
